import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import Chat from './chat/Chat'; // Chat component
import { MessageSquare, X } from 'lucide-react';
import { Outlet } from 'react-router-dom';
import API from '../api'; // Make sure API is imported

export default function DashboardLayout({ user, onLogout }) {

  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 768);
  const [chatOpen, setChatOpen] = useState(false);
  const [totalUnreadCount, setTotalUnreadCount] = useState(0);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth < 768) setSidebarOpen(false);
      else setSidebarOpen(true);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  // 🔁 Poll for unread chat notifications
  useEffect(() => {
    const fetchUnread = () => {
      API.get('/chat/unread')
        .then(res => {
          const count = Object.values(res.data || {}).reduce((sum, val) => sum + val, 0);
          setTotalUnreadCount(count);
        })
        .catch(err => console.error('Failed to fetch unread count:', err));
    };

    fetchUnread(); // initial fetch
    const interval = setInterval(fetchUnread, 3000); // poll every 3s

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 flex relative">
      {/* Sidebar */}
      <Sidebar
        user={user}
        isOpen={sidebarOpen}
        onToggle={toggleSidebar}
        onLogout={onLogout}
        mobileOverlayClose={closeSidebar}
      />

      {/* Overlay for mobile */}
      {sidebarOpen && window.innerWidth < 768 && (
        <div
          onClick={closeSidebar}
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          aria-hidden="true"
        />
      )}

      {/* Main content */}
      <div
        className={`flex-1 transition-all duration-300 ease-in-out relative ${
          sidebarOpen && window.innerWidth >= 768 ? 'ml-56' : 'ml-14'
        }`}
      >
        <Header user={user} onLogout={onLogout} onToggleSidebar={toggleSidebar} />

        <main className="p-6">
          {/* Routed components */}
          <Outlet />
        </main>

        {/* Floating Chat Icon Button */}
        <button
          onClick={() => setChatOpen(!chatOpen)}
          className="fixed bottom-6 right-6 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-lg z-50 flex items-center justify-center"
          title="Toggle Chat"
          aria-label="Toggle Chat"
        >
          {!chatOpen && totalUnreadCount > 0 && (
            <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full z-50">
              {totalUnreadCount}
            </span>
          )}
          {chatOpen ? <X size={24} /> : <MessageSquare size={24} />}
        </button>

        {/* Chat Popup */}
        {chatOpen && (
      <div
        className="fixed bottom-16 right-6 z-50 w-[90vw] max-w-sm h-[80vh] sm:w-[400px] sm:h-[400px]"
      >
        <Chat popup={true} user={user} />
      </div>
        )}
      </div>
    </div>
  );
}
